import { render, staticRenderFns } from "./HotelMap.vue?vue&type=template&id=770bd877&scoped=true&"
import script from "./HotelMap.vue?vue&type=script&lang=js&"
export * from "./HotelMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770bd877",
  null
  
)

export default component.exports